import React, { useEffect, useState } from 'react';
import { bulkAssignCrmHub, getWarehouses } from '../config/api';

const CrmBulkAssignHubDialog = ({ leadIds, onClose, onSaved }) => {
  const [hubs, setHubs] = useState([]);
  const [hubId, setHubId] = useState('');
  const [loadingHubs, setLoadingHubs] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const loadHubs = async () => {
      try {
        const response = await getWarehouses();
        setHubs(response?.data || []);
      } catch (err) {
        setError(err.message || 'Could not load hubs.');
      } finally {
        setLoadingHubs(false);
      }
    };
    loadHubs();
  }, []);

  const submit = async (event) => {
    event.preventDefault();
    if (!hubId) {
      setError('Select a hub.');
      return;
    }

    setSaving(true);
    setError('');
    try {
      const response = await bulkAssignCrmHub(leadIds, Number(hubId));
      if (onSaved) await onSaved(response?.data || response);
      onClose();
    } catch (err) {
      setError(err.message || 'Could not assign the hub.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={saving ? undefined : onClose}>
      <div className="modal-content" onClick={(event) => event.stopPropagation()} style={{ maxWidth: '520px' }}>
        <form onSubmit={submit}>
          <div className="modal-header">
            <h3>Assign Hub</h3>
            <button type="button" className="modal-close" onClick={onClose} disabled={saving}>×</button>
          </div>
          <div className="modal-body">
            <p className="crm-muted">
              Add a hub link to {leadIds.length} selected Lead{leadIds.length === 1 ? '' : 's'}.
              Existing hub links will remain unchanged.
            </p>
            <div className="form-group">
              <label className="form-label" htmlFor="crm-bulk-hub">Hub</label>
              <select
                id="crm-bulk-hub"
                className="form-control"
                value={hubId}
                onChange={(event) => {
                  setHubId(event.target.value);
                  setError('');
                }}
                disabled={loadingHubs || saving}
                autoFocus
              >
                <option value="">{loadingHubs ? 'Loading hubs…' : 'Select a hub'}</option>
                {hubs.map((hub) => (
                  <option key={hub.id} value={hub.id}>
                    {hub.name}{hub.city ? ` — ${hub.city}${hub.state ? `, ${hub.state}` : ''}` : ''}
                  </option>
                ))}
              </select>
            </div>
            {error && <div className="crm-form-error">{error}</div>}
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose} disabled={saving}>Cancel</button>
            <button type="submit" className="btn btn-primary" disabled={saving || loadingHubs || !hubId}>
              {saving ? 'Assigning…' : 'Assign Hub'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CrmBulkAssignHubDialog;
